import type { FieldType } from '@ofmos/shared/field-types';
import type { ComponentType } from 'react';
import { useFieldContext } from '../FieldContext';
import { BooleanInput } from './BooleanInput';
import { CurrencyInput } from './CurrencyInput';
import { DateInput } from './DateInput';
import { DateTimeInput } from './DateTimeInput';
import { EmailInput } from './EmailInput';
import { FilesInput } from './FilesInput';
import { MultiSelectInput } from './MultiSelectInput';
import { NumberInput } from './NumberInput';
import { PhoneInput } from './PhoneInput';
import { RelationInput } from './RelationInput';
import { SelectInput } from './SelectInput';
import { TextInput } from './TextInput';
import { UrlInput } from './UrlInput';

/**
 * INV-12: the input dispatch is the mirror of FIELD_DISPLAYS. Adding a field type
 * to `shared` fails the typecheck in both maps until both halves exist, which is
 * the point - a type that can be stored but not entered is a half-built feature.
 */
export const FIELD_INPUTS: Record<FieldType, ComponentType> = {
  TEXT: TextInput,
  NUMBER: NumberInput,
  BOOLEAN: BooleanInput,
  DATE: DateInput,
  DATETIME: DateTimeInput,
  SELECT: SelectInput,
  MULTI_SELECT: MultiSelectInput,
  RELATION: RelationInput,
  EMAIL: EmailInput,
  PHONE: PhoneInput,
  URL: UrlInput,
  CURRENCY: CurrencyInput,
  FILES: FilesInput,
};

export function FieldInput() {
  const { field } = useFieldContext();
  const Input = FIELD_INPUTS[field.type];
  return <Input />;
}
